import React from 'react';

import {useSelector} from 'react-redux';
import {Navigate} from 'react-router-dom';

import {CheckoutSideReviewConnected} from './checkoutSideReview';
import {PATH_TO_CART} from './constants/checkout';
import {useInitialCheckoutHook} from './hooks/useInitialCheckoutHook/useInitialCheckoutHook';
import {useOnRouterInfoUpdate} from './hooks/useOnRouterInfoUpdate/useOnRouterInfoUpdate';
import {getOrderReviewItemsData} from './store/selectors/orderReviewItems/orderReviewItems';

const CheckoutSetupAndRedirect: React.FC = () => {
    const {list, status} = useSelector(getOrderReviewItemsData);

    useInitialCheckoutHook();
    useOnRouterInfoUpdate();

    if (!list.length && status === 'FULFILLED') {
        return <Navigate to={PATH_TO_CART} />;
    }

    return null;
};

/**
 * Checkout Page Wrapper
 * @param {PropsType} props - Component props
 * @return {React.ReactElement} component
 */
const CheckoutPageWrapper: React.FC = () => {
    return (
        <>
            <CheckoutSetupAndRedirect />
            <CheckoutSideReviewConnected />
        </>
    );
};

export default CheckoutPageWrapper;
